module.exports = __webpack_public_path__ + "static/media/App.952a8515.scss";


//////////////////
// WEBPACK FOOTER
// ./src/App.scss
// module id = 2559
// module chunks = 0